/**
 * @file FirstRunGuide.tsx
 * @description «Как собрать страницу за 5 минут» над структурой (phase19.16
 * Р2; uiux-design-r2 §9; SB101 — простота для маркетолога): пять шагов
 * отмечаются сами по странице — первый экран, текст на канве, свои фото,
 * ещё блоки, страница на сайте. [Скрыть подсказку] запоминается на
 * устройстве; вернуть — «? Как собрать страницу».
 */

import { Check, CircleHelp, X } from "lucide-react";
import { useState } from "react";

import { Button } from "../../ui/button";
import type { SitePageDetail } from "../../../lib/api-site-pages";
import { GUIDE_CANVAS_TEXT_KEY, GUIDE_HIDDEN_KEY, guideSteps, readFlag as read, writeFlag as write } from "../../../lib/site-builder/first-run";
import { cn } from "@/lib/utils";

export function FirstRunGuide({ page }: { page: SitePageDetail }) {
  const [hidden, setHidden] = useState(() => read(GUIDE_HIDDEN_KEY));
  const steps = guideSteps(page, read(GUIDE_CANVAS_TEXT_KEY));
  const doneCount = steps.filter((s) => s.done).length;
  if (hidden) {
    return (
      <Button variant="ghost" size="sm" className="self-start text-on-surface-variant" onClick={() => (write(GUIDE_HIDDEN_KEY, false), setHidden(false))}>
        <CircleHelp aria-hidden />
        Как собрать страницу
      </Button>
    );
  }
  return (
    <section aria-label="Как собрать страницу за 5 минут" className="flex flex-col gap-2 rounded-xl bg-primary/6 p-3">
      <div className="flex items-start gap-2">
        <h3 className="type-body flex-1 font-medium text-on-surface">Как собрать страницу за 5 минут</h3>
        <span className="type-caption tabular-nums text-on-surface-variant">{doneCount} из 5</span>
        <Button variant="ghost" size="icon" className="-m-2 size-10 shrink-0" aria-label="Скрыть подсказку" onClick={() => (write(GUIDE_HIDDEN_KEY, true), setHidden(true))}>
          <X aria-hidden />
        </Button>
      </div>
      <ol className="flex flex-col gap-1">
        {steps.map((step, i) => (
          <li key={step.label} className={cn("type-caption flex items-start gap-2", step.done ? "text-on-surface-variant line-through" : "text-on-surface")}>
            <span aria-hidden className={cn("flex size-5 shrink-0 items-center justify-center rounded-full", step.done ? "bg-success text-on-primary" : "bg-surface-lowest [box-shadow:inset_0_0_0_1px_var(--outline-variant)]")}>
              {step.done ? <Check className="size-3" /> : i + 1}
            </span>
            <span>
              {step.label}
              {step.done ? <span className="sr-only"> — сделано</span> : null}
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
}
